module.exports = __webpack_public_path__ + "img/MES6Indice2_cutout.364d04fa.png";